<template>
	<div ref="container" class="lottie-container"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";

const props = defineProps({
	animationData: {
		type: Object,
		required: true,
	},
	loop: {
		type: Boolean,
		default: true,
	},
	autoplay: {
		type: Boolean,
		default: true,
	},
});

const container = ref(null);
let animationInstance = null;
let lottieModulePromise = null;

const loadLottie = async () => {
	if (!lottieModulePromise) {
		lottieModulePromise = import("lottie-web");
	}
	const module = await lottieModulePromise;
	return module.default || module;
};

const mountAnimation = async () => {
	if (!import.meta.client || !container.value) return;

	if (animationInstance) {
		animationInstance.destroy();
		animationInstance = null;
	}

	const lottie = await loadLottie();
	animationInstance = lottie.loadAnimation({
		container: container.value,
		renderer: "svg",
		loop: props.loop,
		autoplay: props.autoplay,
		animationData: props.animationData,
	});
};

onMounted(() => {
	void mountAnimation();
});

onUnmounted(() => {
	if (animationInstance) {
		animationInstance.destroy();
	}
});

watch(
	() => props.autoplay,
	newVal => {
		if (animationInstance) {
			if (newVal) {
				animationInstance.play();
			} else {
				animationInstance.pause();
			}
		}
	}
);

watch(
	() => props.animationData,
	() => {
		void mountAnimation();
	}
);

defineExpose({
	play: () => animationInstance?.play(),
	pause: () => animationInstance?.pause(),
	stop: () => animationInstance?.stop(),
});
</script>

<style scoped>
.lottie-container {
	display: inline-block;
}
</style>
